var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAllformats(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 43,
    viewBox: "0 0 61 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M41.1819 43L7.53327 43C3.36905 43 0 39.5246 0 35.2289L0 7.77108C0 3.4754 3.36905 0 7.53327 0L41.2028 0C45.367 0 48.7361 3.4754 48.7361 7.77108L48.7361 35.2073C48.7152 39.5246 45.3461 43 41.1819 43Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M58.802 41.7483L48.7158 35.7257L48.7158 7.27494L58.802 1.25235C59.7437 0.691107 60.8946 1.38187 60.8946 2.50436L60.8946 40.4963C60.8946 41.5972 59.7228 42.288 58.802 41.7483Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M58.802 41.7483L48.7158 35.7257L48.7158 7.27494L58.802 1.25235C59.7437 0.691107 60.8946 1.38187 60.8946 2.50436L60.8946 40.4963C60.8946 41.5972 59.7228 42.288 58.802 41.7483Z",
    fill: "url(#paint0_radial_310_110)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M9.60534 14.4851C12.1941 14.4851 14.2927 12.3203 14.2927 9.6498C14.2927 6.97931 12.1941 4.81445 9.60534 4.81445C7.01657 4.81445 4.91797 6.97931 4.91797 9.6498C4.91797 12.3203 7.01657 14.4851 9.60534 14.4851Z",
    fill: "url(#paint1_radial_310_110)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M8.49627 12.175C10.4725 12.175 12.0746 10.5224 12.0746 8.48374C12.0746 6.44511 10.4725 4.79248 8.49627 4.79248C6.52003 4.79248 4.91797 6.44511 4.91797 8.48374C4.91797 10.5224 6.52003 12.175 8.49627 12.175Z",
    fill: "url(#paint2_linear_310_110)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_310_110",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(37.0727 21.39) scale(22.6574 23.3726)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBBAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2336,
    stopColor: "#CEBEFF",
    stopOpacity: 0.766
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4799,
    stopColor: "#D8CBFF",
    stopOpacity: 0.52
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7321,
    stopColor: "#E8E0FF",
    stopOpacity: 0.268
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9869,
    stopColor: "#FEFDFF",
    stopOpacity: 0.013
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_310_110",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(9.60178 9.64202) scale(4.69281 4.84095)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBBAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2336,
    stopColor: "#CEBEFF",
    stopOpacity: 0.766
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4799,
    stopColor: "#D8CBFF",
    stopOpacity: 0.52
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7321,
    stopColor: "#E8E0FF",
    stopOpacity: 0.268
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9869,
    stopColor: "#FEFDFF",
    stopOpacity: 0.013
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_310_110",
    x1: -11.5732,
    y1: -12.202,
    x2: 69.3378,
    y2: 66.2331,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003EE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#010B26"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllformats);
export default __webpack_public_path__ + "static/media/allformats.afabf6e933b087a28cdb3e318c383057.svg";
export { ForwardRef as ReactComponent };